var XMLFile		 = require('../xml/XMLFile'),
	SharedString	= require('./SharedString');

/**
 * The SharedStrings class represents the list of shared String
 * objects that is used in the Office Open XMl Spreadsheet. The
 * SharedStrings object reduces redundancy within the data by
 * providing a reference to unique Strings instead of repeating
 * them.
 *
 * Due to the fact that the Strings are shared within the whole
 * workbook, each instance of the document export only has one
 * single instance of SharedString and therefore it uses the
 * Singleton pattern to ensure this.
 *
 * @class
 */
function SharedStrings() {
	if (SharedStrings.instance instanceof SharedStrings) {
		return SharedStrings.instance;
	}

	XMLFile.call(this, SharedStrings.metadata);

	Object.defineProperty(this, 'map', {value: new Map(), writable: false});
	Object.defineProperty(this, '_shared', {value: new SharedString(''), writable: false});

	SharedStrings.instance = this;
}

SharedStrings.prototype = Object.create(XMLFile.prototype);
SharedStrings.prototype.constructor = SharedStrings;

/**
 * Retrieves the Singleton instance of SharedStrings. If no instance is present, it will create one.
 *
 * @function
 * @returns {object} - Singleton instance
 */
SharedStrings.getInstance = function() {
	if (!SharedStrings.instance) {
		SharedStrings.instance = new SharedStrings();
	}

	return SharedStrings.instance;
};

SharedStrings.metadata = {
	filename: 'sharedStrings.xml',
	tag: 'sst',
	root: true,
	attributes: [
		{
			name: 'xmlns',
			value: 'http://schemas.openxmlformats.org/spreadsheetml/2006/main'
		}

		/*
		,{
			name: 'count', // Optional as long as uniqueCount is not set
			value: '0'
		},
		{
			name : 'uniqueCount', // Optional as long as count is not set
			value: '0'
		}
		*/
	]
};

/**
 * Adds the specified string value to the set of SharedStrings. The
 * method creates a SharedString proxy object that contains
 * information about the string itself as well as its index. The
 * index is zero-based and can be used for referencing within Cell
 * objects.
 *
 * @function insert
 * @param {string} sValue - The string that has to be inserted
 * @return {object} - The SharedString instance that represents the provided string value
 */
SharedStrings.prototype.insert = function(sValue) {
	var index;

	if (this.map.has(sValue)) {
		return this.map.get(sValue);
	}

	this._shared.setValue(sValue);
	index = this.map.size;
	this.map.set(sValue, index);

	/* The SharedString needs to be added to the child nodes as well for serialization purposes */
	this.childs.push(this._shared.serialize());

	return index;
};

/**
 * Cleanup hook that gets executed when the XMLFil#serialize function
 * is called with the finalize flag.
 *
 * @private
 */
SharedStrings.prototype.cleanup = function() {
	this.map.clear();
};

module.exports = SharedStrings;


//////////////////
// WEBPACK FOOTER
// ./core/xlsx/src/data/SharedStrings.js
// module id = 15
// module chunks = 0